import { NBSP } from 'shared/constants/symbols';

import { IJsonQueryUnderground } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoUndergroundTagsManager = createGeoTagsManager<IJsonQueryUnderground>({
  jsonQueryKey: 'underground',
  labelGetter: ({ geoTags, geoValue }) => {
    const { name, releaseYear } = geoTags.undergrounds[geoValue.id];

    if (!name) {
      return 'Неизвестная станция';
    }

    if (releaseYear) {
      return `${name}${NBSP}·${NBSP}${releaseYear}`;
    }

    return name;
  },
  id: 'geoUnderground',
  getLeftAdornment: ({ geoTags, geoValue, regionId }) => {
    const { color } = geoTags.undergrounds[geoValue.id];

    return color ? { type: 'undergroundIcon', props: { color, regionId: regionId as number } } : undefined;
  },
});
